import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  updateModal: false,   
  showUpdateCard: false, 
  status: null
};

const updateSlice = createSlice({
  name: "update",
  initialState,
  reducers: {
    setUpdateModal: (state, action) => {
      state.updateModal = action.payload;
    },
    toggleUpdateModal: (state) => {
      state.updateModal = !state.updateModal;
    },

    setShowUpdateCard: (state, action) => {
      state.showUpdateCard = action.payload;
    },

    setStatus: (state, action) => {
      state.status = action.payload;
    }
  }
});

export const { setUpdateModal, toggleUpdateModal, setStatus,setShowUpdateCard } = updateSlice.actions;
export default updateSlice.reducer;